import React, { useState, useEffect } from 'react';
import { CircularProgress, Container, Typography } from '@mui/material';
import { fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
import { IS_TEST_MODE } from '../../../../awsConfig';
import ThemeLayout from '../layouts/ThemeLayout';
import { THEME_CONFIG } from '../themes';

const ALLOWED_ADMIN_EMAILS = ['navin.gelot@valensdatalabs.com', 'form-global@ls.com', 'kpapasso@legalstream.org'];

const AdminCheck = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userEmail, setUserEmail] = useState('');

    useEffect(() => {
        const checkAdminAccess = async () => {
            try {
                if (IS_TEST_MODE) {
                    setIsAdmin(true);
                    setUserEmail('test@example.com');
                    setIsLoading(false);
                    return;
                }

                const user = await getCurrentUser();
                const attrs = await fetchUserAttributes();
                const email = attrs.email || '';

                setUserEmail(email);

                console.log(`Admin check: ${email}`, ALLOWED_ADMIN_EMAILS.includes(email));

                if (ALLOWED_ADMIN_EMAILS.includes(email)) {
                    setIsAdmin(true);
                } else {
                    console.warn(`Access denied for email: ${email}`);
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error('Error checking admin access:', error);
                setIsAdmin(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkAdminAccess();
    }, []);

    if (isLoading) {
        return (
            <ThemeLayout themeType={THEME_CONFIG.user}>
                <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Checking admin access...</Typography>
                </Container>
            </ThemeLayout>
        );
    }

    if (!isAdmin) {
        return (
            <ThemeLayout themeType={THEME_CONFIG.user}>
                <Container maxWidth="md" sx={{ py: 4 }}>
                    <Typography variant="h4" gutterBottom color="error">
                        Access Denied
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        You don't have permission to access the admin portal.
                    </Typography>
                    {userEmail && (
                        <Typography variant="body2" color="text.secondary">
                            Logged in as: <strong>{userEmail}</strong>
                        </Typography>
                    )}
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Please contact your administrator for access.
                    </Typography>
                </Container>
            </ThemeLayout>
        );
    }

    // Admin users get the admin theme (dark)
    return (
        <ThemeLayout themeType={THEME_CONFIG.admin}>
            {children}
        </ThemeLayout>
    );
};

export default AdminCheck;